import { render, staticRenderFns } from "./PanelSection.vue?vue&type=template&id=8e4962d2&scoped=true&"
import script from "./PanelSection.vue?vue&type=script&lang=js&"
export * from "./PanelSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4962d2",
  null
  
)

export default component.exports